import { colors } from "./tokens";
// ─────────────────────────────────────────────────────────────────────────────
// src/theme.ts  ·  AVDASH brand theme
// Primary: #1D5BA8 (deep blue)   Accent: #7FC8BD (teal)
// ─────────────────────────────────────────────────────────────────────────────

const THEME = {
  colors: {
    // Primary – AVDASH blue
    primary:       colors.brand[600],
    primaryDark:   colors.brand[700],
    primaryLight:  colors.brand[400],
    primaryMuted:  colors.neutral[100],

    // Accent – AVDASH teal
    accent:        colors.accent[300],
    accentDark:    colors.accent[500],
    accentLight:   colors.accent[200],
    accentMuted:   colors.accent[50],

    // Rows zone – teal
    rowsZone:      colors.accent[300],
    rowsZoneMuted: 'rgba(127,200,189,0.08)',

    // Columns zone – blue
    columnsZone:      colors.brand[600],
    columnsZoneMuted: 'rgba(29,91,168,0.08)',

    // Navigation / App Shell
    headerBgFrom:      colors.brand[600],
    headerBgTo:        colors.brand[700],
    headerBorder:      'rgba(127,200,189,0.18)',
    headerText:        colors.neutral[0],
    headerTextMuted:   'rgba(255,255,255,0.45)',
    headerGlow:        colors.accent[300],

    // Sub-header search bar
    searchBarBgFrom:         colors.brand[600],
    searchBarBgTo:           colors.brand[500],
    searchBarBorder:         'rgba(127,200,189,0.14)',
    searchBarInputBg:        'rgba(255,255,255,0.08)',
    searchBarInputBorder:    'rgba(127,200,189,0.25)',
    searchBarInputText:      colors.neutral[0],
    searchBarChipBg:         colors.brand[600],
    searchBarChipText:       colors.neutral[0],

    // Dimensions panel
    dimPanelHeaderBg1: colors.brand[600],
    dimPanelHeaderBg2: colors.brand[700],
    dimChipBg:         colors.neutral[100],
    dimChipText:       colors.brand[700],
    dimChipBorder:     colors.brand[300],
    dimChipInRows:     'rgba(127,200,189,0.13)',
    dimChipInCols:     'rgba(29,91,168,0.13)',
    dimChipIcon:       colors.brand[400],

    // Measures sidebar
    measureGroupBg:      'rgba(29,91,168,0.07)',
    measureGroupText:    colors.brand[600],
    measureCheckedBg:    'rgba(29,91,168,0.07)',
    measureCheckedText:  colors.brand[600],
    measureUncheckedText:colors.neutral[700],

    // Table
    tableHeaderGroup:    colors.brand[900],
    tableHeaderChild:    colors.brand[700],
    tableHeaderDim:      colors.neutral[900],
    tableHeaderText:     colors.neutral[0],
    tableBorder:         colors.brand[300],
    tableDataBorder:     colors.brand[100],
    tableRowEven:        colors.neutral[0],
    tableRowOdd:         colors.neutral[100],
    tableRowSubtotal:    colors.neutral[100],
    tableDimCell:        colors.neutral[100],
    tableGrandTotal:     colors.brand[900],
    tableGrandTotalText: colors.accent[200],

    // Cards / surfaces
    cardBg:     colors.neutral[0],
    cardBorder: colors.brand[100],
    cardShadow: 'rgba(29,91,168,0.09)',
    pageBg:     colors.neutral[100],

    // Text
    textPrimary:   colors.brand[900],
    textSecondary: colors.brand[600],
    textMuted:     colors.brand[300],

    // Feedback
    danger:       colors.danger[500],
    dangerBg:     colors.neutral[100],
    dangerBorder: colors.danger[100],
    success:      colors.accent[400],
    warning:      colors.warning[500],
    warningBg:    colors.warning[100],

    // Chart palette – blue/teal family + contrasts
    chart: [
      '#1D5BA8',  // AVDASH blue
      '#7FC8BD',  // AVDASH teal
      '#D98E04',  // amber
      '#D64545',  // red
      '#4A86C7',  // violet
      '#7DA8D9',  // cyan
      '#D98E04',  // orange
      '#4DB3A5',  // emerald
      '#7DA8D9',  // pink
      '#4A86C7',  // indigo
    ],
  },

  fonts: {
    heading: "Poppins, Inter, system-ui, sans-serif",
    body:    "Inter, system-ui, -apple-system, sans-serif",
  },

  radii: {
    xs:   '3px',
    sm:   '6px',
    md:   '8px',
    lg:   '12px',
    full: '9999px',
  },

  shadows: {
    card:         '0 2px 12px rgba(29,91,168,0.09)',
    popover:      '0 8px 30px rgba(15,23,42,0.16)',
    header:       '0 2px 16px rgba(13,42,80,0.40)',
    tableWrapper: '0 2px 12px rgba(29,91,168,0.09)',
    chip:         '0 1px 4px rgba(15,23,42,0.12)',
  },

  appBarHeight:    60,
  searchBarHeight: 46,
};

export type AppTheme = typeof THEME;
export default THEME;
